import {useState} from "react";

const Searchbar = () => {

    const [isActive, setIsActive] = useState(false);

    return <div className={isActive ? 'searchbar active' : 'searchbar'}>
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="4.3" stroke="#8F9BBA" stroke-width="1.4"/>
            <line x1="10.0101" y1="11" x2="8" y2="8.98995" stroke="#8F9BBA" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
        <input
            onFocus={() => {
                setIsActive(true)
            }}
            onBlur={() => {
                setIsActive(false)
            }}
            // onKeyDown={(e) => {
            //     if (e.key === 'Enter') {
            //         e.target.blur();
            //     }
            // }}
            type="search" placeholder="Rechercher"/>
        <div className="searchcontent" style={{
            opacity: isActive ? 1 : 0,
            pointerEvents: isActive ? 'auto' : 'none',
            bottom: isActive ? 'calc(-20vh - 1vh)' : '-80px',
            height: '20vh',
        }}></div>
    </div>
}

export default Searchbar;